import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Acasa from "./pages/Acasa";
import AnimaleGasite from "./pages/AnimaleGasite";
import AnimalePierdute from "./pages/AnimalePierdute";
import SucceseFindMyPet from "./pages/SucceseFindMyPet";
import RaporteazaAnimalutGasit from "./pages/RaporteazaAnimalutGasit";
import RaporteazaAnimalutPierdut from "./pages/RaporteazaAnimalutPierdut";
import AuthCallback from "./pages/AuthCallback";   // ← NOU
import Cont from "./pages/Cont";                   // ← NOU
import PromovareSucces from "./pages/PromovareSucces";

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Acasa />} />
          <Route path="/animale-gasite" element={<AnimaleGasite />} />
          <Route path="/animale-pierdute" element={<AnimalePierdute />} />
          <Route path="/succese-findmypet" element={<SucceseFindMyPet />} />
          <Route path="/RaporteazaAnimalutGasit" element={<RaporteazaAnimalutGasit />} />
          <Route path="/RaporteazaAnimalutPierdut" element={<RaporteazaAnimalutPierdut />} />
          <Route path="/promovare-succes" element={<PromovareSucces />} />
          <Route path="/cont" element={<Cont />} />  {/* ← NOU */}
        </Route>
        {/* În afara Layout — fără navbar/footer */}
        <Route path="/auth/callback" element={<AuthCallback />} />  {/* ← NOU */}
      </Routes>
    </Router>
  );
}

export default App;